import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CitizenComponent } from 'src/app/pages/citizen/citizen.component';
import { GerinusToolsModule } from '../../lib/gerinus-tools.module';
import { AppCoreModule } from '../../app-core.module';
import { ComponentsModule } from 'src/app/components/components.module';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { SidebarModule } from 'primeng/sidebar';
import { ToastModule } from 'primeng/toast';
import { BlockUIModule } from 'ng-block-ui';
import { DialogModule } from 'primeng/dialog';
import { CalendarModule } from 'primeng/calendar';
import { MultiSelectModule } from 'primeng/multiselect';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'primeng/api';
import { RequestsModule } from '../requests/requests.module';



@NgModule({
  imports: [
    CommonModule,
    GerinusToolsModule,
    AppCoreModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    AutoCompleteModule,
    SharedModule,
    SidebarModule,
    ToastModule,
    BlockUIModule,
    DialogModule,
    CalendarModule,
    MultiSelectModule,
    CheckboxModule,
    DropdownModule,
  ],
  declarations: [CitizenComponent],
  exports: [GerinusToolsModule, RequestsModule],
})
export class CitizenModule { }
